import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_NEW_PETITION_PAGE_GOOGLE_ADDRESS_EXPERIMENT = defineFcm('new_petition_page_google_address_experiment')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				enabled: { type: 'boolean' },
				experimentName: { type: 'string', optional: true },
				localExperimentName: { type: 'string', optional: true },
			},
		}),
	)
	.withDefault({
		enabled: false,
		experimentName: undefined,
		localExperimentName: undefined,
	})
	.toConfig();
